<template>
  <a-select
    v-model="value"
    :options="options"
    show-search
    allowClear
    :filter-option="false"
    placeholder="输入搜索类目，并选择"
    :loading="loading"
    @search="handleSearch"
    @change="change"
  />
</template>
<script>
import { queryCateList } from "@/api";
export default {
  model: {
    prop: "modelValue",
    event: "select"
  },
  props: {
    modelValue: String,
    platform: {
      type: String,
      required: e =>
        ["tb", "ks", "jd", "mt", "ele", "dy", "ali", "pdd", "xhs"].includes(e)
    },
    name: String
  },
  data() {
    return {
      value: undefined,
      options: [],
      timer: null,
      loading: false
    };
  },
  mounted() {
    if (this.modelValue) {
      this.value = this.modelValue;
      this.options = [{ label: this.name, value: this.value }];
    }
  },
  methods: {
    async getCateList(name) {
      this.options = [];
      const { platform } = this;
      this.loading = true;
      const res = await queryCateList({
        pageSize: 1000,
        platform: this.platform,
        [`${platform}Name`]: name
      }).catch(e => {
        console.log("[e] ---> ", e);
        this.loading = false;
      });
      this.loading = false;
      if (res.success) {
        this.options = res.data.list.map(val => ({
          ...val,
          label: val[`${platform}Name`],
          value: val[`${platform}Id`]
        }));
      }
    },
    handleSearch(e) {
      if (this.timer) clearTimeout(this.timer);
      if (e) {
        this.timer = setTimeout(() => this.getCateList(e), 1000);
      }
    },
    change() {
      const find = this.options.find(val => this.value === val.value);
      if (find) {
        this.$emit("select", this.value);
        this.$emit("nameChange", find.label);
      }
    }
  }
};
</script>
